import { setAttr } from './dom';
export const expressionPool = [];
const expressionObservers = [];
const expressionObserverAttrs = [];
const freeExpressionPointers = [];
let cursor = 0;
export function createExpressionBlock(len) {
    const bucket = freeExpressionPointers[len];
    const pointer = bucket?.length ? bucket.pop() : cursor;
    expressionPool[pointer] = len;
    if (pointer === cursor)
        cursor += len + 1;
    return pointer;
}
export function writeExpressions(expSlots, pointer, offset = 0) {
    const len = expressionPool[pointer];
    for (let i = 1; i <= len; i++) {
        const nextValue = expSlots[offset + i - 1];
        const target = pointer + i;
        if (Object.is(expressionPool[target], nextValue))
            continue;
        expressionPool[target] = nextValue;
        const observer = expressionObservers[target];
        if (!observer)
            continue;
        const attr = expressionObserverAttrs[target];
        if (attr !== undefined)
            setAttr(observer, attr, nextValue);
        else if (typeof observer === 'function')
            observer(nextValue);
        else
            observer.data = nextValue || nextValue === 0 ? nextValue : '';
    }
}
export function onExpressionUpdate(pointer, observer, attrName) {
    expressionObservers[pointer] = observer;
    expressionObserverAttrs[pointer] = attrName;
}
export function releaseExpressions(pointer) {
    const len = expressionPool[pointer];
    if (len === undefined)
        return;
    for (let i = 0; i <= len; i++) {
        expressionPool[pointer + i] = undefined;
        expressionObservers[pointer + i] = undefined;
        expressionObserverAttrs[pointer + i] = undefined;
    }
    ;
    (freeExpressionPointers[len] ??= []).push(pointer);
}
